// extracted by mini-css-extract-plugin
export default {"root":"IconCrionTravel_root__ymNJt"};